import { Text } from 'tamagui';

import { isEmpty } from '../../misc';

export const toSuperscript = (n: number): string =>
    SUPERSCRIPT_CHARACTERS[n] ?? '*';

const SUPERSCRIPT_CHARACTERS = [
    '⁰',
    '¹',
    '²',
    '³',
    '⁴',
    '⁵',
    '⁶',
    '⁷',
    '⁸',
    '⁹',
];

interface SuperscriptTextProps {
    textBefore?: string;
    superscript: number;
    textAfter?: string;
    onInvalidSuperscriptText?: (error: string) => void;
    textComponent?: React.ComponentType<{ children: React.ReactNode }>;
    textProps?: Record<string, unknown>;
    children?: React.ReactNode;
}

export const SuperscriptText = ({
    textBefore,
    superscript,
    textAfter,
    onInvalidSuperscriptText,
    textComponent: TextComponent = Text,
    textProps,
    children,
}: SuperscriptTextProps) => {
    if (superscript < 0 || superscript > 9) {
        if (onInvalidSuperscriptText) {
            onInvalidSuperscriptText(
                `SuperscriptText: Superscript value ${superscript} is not supported`,
            );
        }
    }

    const superscriptString = SUPERSCRIPT_CHARACTERS[superscript] ?? '*';

    return (
        <TextComponent {...textProps}>
            {!isEmpty(textBefore) && `${textBefore}`}
            {superscriptString}
            {!isEmpty(textAfter) && ` ${textAfter}`}
            {children}
        </TextComponent>
    );
};
